export default __webpack_public_path__ + "static/media/ic-art-target.29f8aa3e.svg";